import { useQuery } from 'react-query';
import { useAccessToken } from 'utils/auth';
import { fetchAssignmentDetails } from './api';
import { USE_ASSIGNMENT_DETAILS_QUERY_KEY } from './constants';

export const useAssignmentDetailsQuery = (assignmentId: string | undefined) => {
  const { token } = useAccessToken();

  return useQuery(
    [USE_ASSIGNMENT_DETAILS_QUERY_KEY, assignmentId],
    () => fetchAssignmentDetails(token, assignmentId),
    {
      enabled: !!(token && assignmentId),
      retry: (failureCount, error) => {
        // Don't retry on authentication errors or client errors
        if (error instanceof Error && error.message.includes('401')) {
          return false;
        }
        // Retry up to 3 times for network errors
        return failureCount < 3;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 10000), // Exponential backoff
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000 // 10 minutes
    }
  );
};
